import React, { useEffect, useState } from "react";
import styles from "./language.module.scss";
import Button from "../../components/Button";
import { category, langs, Langstat } from "./types";
import Icon from "../../components/Icon";
import AddLanguage from "./components/languageFields/AddLanguage";
import AddSpoken from "./components/languageFields/AddSpoken";
import { addLanguage } from "./types";
import { setLanguages, getSpoken, getTaught } from "../../features/Profile";
import { useMutation, useQuery } from "@tanstack/react-query";
import { toast } from "sonner";
import { useQueryClient } from "@tanstack/react-query";
import useLanguages from "../../context/LanguagesContext";
import { ILanguage } from "../../types/language";
import { ClipLoader } from "react-spinners";


const LanguageSettings = () => {
  const { languages_taught } = useLanguages();

  const queryClient = useQueryClient();
  const [steps, setStep] = useState<string>("list");
  const [teaching, setTeaching] = useState<langs[]>([]);
  const [speaks, setSpeaks] = useState<langs[]>([]);
  const [langList, setLangList] = useState<ILanguage[]>([]);

  useEffect(() => {
    if (languages_taught) {
      setLangList(languages_taught);
    }
  }, [languages_taught]);

  const [taughtLang, setTaughtLang] = useState<addLanguage>({
    languages: [
      {
        language: "",
        proficiency: "",
      },
    ],
    category: category.TAUGHT,
  });

  const [spokenLang, setSpokenLang] = useState<addLanguage>({
    languages: [
      {
        language: "",
        proficiency: "",
      },
    ],

    category: category.SPOKEN,
  });

  const handleDelete = (id: number) => {
    // console.log(id);
  };


  const { mutateAsync: setLanguage, isPending } = useMutation({
    mutationFn: setLanguages,
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ["getSpoken"] });
      queryClient.invalidateQueries({ queryKey: ["getTaught"] });

      toast.success(`language Addded`, {
        richColors: true,
      });

      setStep("list");
    },
    onError: (err) => {
      toast.error(err.message ?? `Failed to add language`, {
        richColors: true,
      });
    },
  });

  const {
    data: langSpoken,
    isPending: SpokenPending,
    isError: SpokenError,
  } = useQuery({
    queryKey: ["getSpoken"],
    queryFn: getSpoken,
  });

  const {
    data: langTaught,
    isPending: TaughtPending,
    isError: TaughtError,
  } = useQuery({
    queryKey: ["getTaught"],
    queryFn: getTaught,
  });

  useEffect(() => {
    if (langTaught) {
      setTeaching(langTaught?.data?.result);
    }
  }, [langTaught]);

  useEffect(() => {
    if (langSpoken) {
      setSpeaks(langSpoken?.data?.result);
    }
  }, [langSpoken]);

  useEffect(() => {
    if (SpokenError) {
      toast.error(`Failed to get spoken languages`, {
        richColors: true,
      });
    }
  }, [SpokenError]);

  useEffect(() => {
    if (TaughtError) {
      toast.error(`Failed to get taught languages`, {
        richColors: true,
      });
    }
  }, [TaughtError]);

  const SubmitLanguage = (e: any, type: string) => {
    e.preventDefault();
    if (type === "spoken") {
      let isExists = speaks.some(
        (item: langs) =>
          item.language.toLocaleLowerCase() === spokenLang?.languages[0]?.language.toLowerCase()
      );
      !isExists
        ? setLanguage(spokenLang)
        : toast.warning(
            `The ${spokenLang?.languages[0]?.language} language has already been added. Please add another language you speak`,
            {
              richColors: true,
            }
          );
    } else if (type === "taught") {
      let isExists = speaks.some(
        (item: langs) =>
          item.language.toLocaleLowerCase() === taughtLang?.languages[0]?.language.toLowerCase()
      );
      !isExists
        ? setLanguage(taughtLang)
        : toast.warning(
            `${taughtLang?.languages[0]?.language} has already been selected. Please select another language you would like to teach`,
            {
              richColors: true,
            }
          );
    }
  };

  //table for the languages
  const Table: React.FC<{ tableData: langs[] }> = ({ tableData }) => {
    return (
      <div className={styles.tableCont}>
        <table className={styles.table}>
          <thead className={styles.thead}>
            <tr>
              <th>Langauge</th>
              <th>Proficiency</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {tableData?.map((data: langs, index: number) => (
              <tr key={index}>
                <td>{data.language}</td>
                <td>{data.proficiency}</td>
                <td
                  className={`${
                    data?.status === Langstat.APPROVED
                      ? `${styles.blue}`
                      : data?.status === Langstat.PENDING && `${styles.yellow}`
                  }`}
                >
                  {data.status}
                </td>
                {/* <td onClick={() => handleDelete(index)}>
                  <Icon name="close" />
                </td> */}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <>
      <div className={styles.langCont}>
        {steps === "list" ? (
          <>
            <div className={styles.language}>
              <div className={styles.header}>
                <h4>Languages to teach</h4>
                <Button
                  variant="secondary"
                  onClick={() => {
                    setStep("language");
                  }}
                >
                  Add Language to teach
                </Button>
              </div>
              {TaughtPending ? (
                <div className={styles.AppLoader}>
                  <ClipLoader size={30} />
                </div>
              ) : (
                langTaught && <Table tableData={teaching} />
              )}
            </div>

            <div>
              <div className={styles.spoken}>
                <div className={styles.header}>
                  <h4>Spoken languages</h4>
                  <Button
                    variant="secondary"
                    onClick={() => {
                      setStep("spoken");
                    }}
                  >
                    Add Spoken Language
                  </Button>
                </div>
                {SpokenPending ? (
                  <div className={styles.AppLoader}>
                    <ClipLoader size={30} />
                  </div>
                ) : (
                  langSpoken && <Table tableData={speaks} />
                )}
              </div>
            </div>
          </>
        ) : steps === "language" ? (
          <div className={styles.add}>
            <div className={styles.addhead} onClick={() => setStep("list")}>
              <Icon name="left_arrow" />
              <h2>Add New Language To Teach</h2>
            </div>
            <AddLanguage
              value={taughtLang}
              setValue={setTaughtLang}
              handleSubmit={SubmitLanguage}
              setStep={setStep}
              languageList={langList}
              isLoading={isPending}
            />
          </div>
        ) : (
          steps === "spoken" && (
            <div className={styles.add}>
              <div className={styles.addhead} onClick={() => setStep("list")}>
                <Icon name="left_arrow" />
                <h2>Add New Spoken Language </h2>
              </div>
              <AddSpoken
                value={spokenLang}
                setValue={setSpokenLang}
                handleSubmit={SubmitLanguage}
                setStep={setStep}
                languageList={langList}
                isLoading={isPending}
              />
            </div>
          )
        )}
      </div>
    </>
  );
};

export default LanguageSettings;
